import { useEffect, useState } from "react";
import { CreateAncestorsLineageForSidePanel } from "@src/cloud-connect/node-manager/entities/create-ancestors-lineage-for-side-panel";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export const useMachineAncestorsLineageTreeHook = (nodeId) => {
  const machineStructureNodeset = getMachineStructureNodeset();
  const ancestorsLineageCreator = new CreateAncestorsLineageForSidePanel();

  const [machineLocationAncestors, setMachineLocationAncestors] = useState(
    ancestorsLineageCreator.createMachineStructureAncestorsLineageForSidePanel(
      nodeId,
    ),
  );

  useEffect(() => {
    const updateAncestors = () => {
      const updatedAncestors =
        ancestorsLineageCreator.createMachineStructureAncestorsLineageForSidePanel(
          nodeId,
        );
      setMachineLocationAncestors(updatedAncestors);
    };

    // update immediately in case data is already available
    updateAncestors();
    machineStructureNodeset.addObserver(updateAncestors);

    return () => {
      machineStructureNodeset.removeObserver(updateAncestors);
    };
  }, [nodeId, machineStructureNodeset]);

  return machineLocationAncestors;
};
